module.exports = __webpack_public_path__ + "static/img/police.d0289dc0.png";